var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 77,
    viewBox: "0 0 84 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7537 34.0163C44.4453 33.9854 44.0753 33.9854 43.7362 34.0163C36.3978 33.7696 30.5703 27.7571 30.5703 20.3571C30.5703 12.8029 36.6753 6.66711 44.2603 6.66711C51.8145 6.66711 57.9503 12.8029 57.9503 20.3571C57.9195 27.7571 52.092 33.7696 44.7537 34.0163Z",
    stroke: "#FF8AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3228 45.3929C21.8611 50.3879 21.8611 58.5279 29.3228 63.492C37.802 69.1654 51.7078 69.1654 60.187 63.492C67.6486 58.497 67.6486 50.3571 60.187 45.3929C51.7386 39.7504 37.8328 39.7504 29.3228 45.3929Z",
    stroke: "#FF8AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 57.5,
    r: 19,
    fill: "#EA1D63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 52L25 64M25 52L13 64",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMember);
export default __webpack_public_path__ + "static/media/removeMember.fbf64a893cee1ddc42dd6720716b5e91.svg";
export { ForwardRef as ReactComponent };